export default __webpack_public_path__ + "static/media/deep-dive.0715d825f9f83ee0ec88ca68f95de6df.svg";